import { type CustomResolversContext } from '../types';

const myAvatar = async (root: any, args: { userId: string }, context: CustomResolversContext) => {
	const { userId } = args;
	const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;

	return context.fetch(url).then((data) => data.json());
};

export default myAvatar;
